import React from "react";
import { CircularProgress } from "@material-ui/core";
import "./Loader.scss";
import { LoaderInterface } from "../../../interfaces";
import { useIntl } from "react-intl";

const Loader = (props: LoaderInterface) => {
  const intl = useIntl();
  return (
    <div>
      {props.showLoader && (
        <div className="LoaderContainer">
          <div className="loader_img">
            <CircularProgress aria-label={`${intl.formatMessage({"id":'page_loading_aria'})}`} className="loader" size={35} style={{ color: "primary" }} />
          </div>
        </div>)
      }
    </div>);
};

export default Loader;
